<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<!-- <div class="d-flex m-0 align-items-center">
  <h3 class="ms-2 mt-2">Preventivi salvati</h3>
</div> -->

<div class="d-flex mt-3 ms-1 mb-2 justify-content-between align-items-center hidden-mobile">
  <h3>Preventivi salvati</h3>
  <div class="me-1 custom-select-wrapper">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <!-- <mat-label>Seleziona anno</mat-label> -->
      <mat-select [(value)]="selectedYear" (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="w-100 mb-2 visible-mobile custom-rounded">
  <div class="custom-select-wrapper">
    <mat-form-field appearance="fill" class="mb-0 w-100 custom-rounded" subscriptSizing="dynamic">
      <!-- <mat-label>Seleziona anno</mat-label> -->
      <mat-select class="custom-rounded" [(value)]="selectedYear" (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<!-- <mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column text-button-card custom-card">
  <div class="d-flex justify-content-between align-items-center mb-0">
    <button
      class="ms-auto"
      matButton="filled"
      color="primary"
      (click)="navigateToNewpreventive()"
    >
    <mat-icon>add</mat-icon>
      New preventive
    </button>
  </div>
</mat-card> -->

<!-- filter panel -->
<mat-accordion class="me-2 col-md-12 d-flex flex-column">
  <mat-expansion-panel [(expanded)]="filterPanelOpenState">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>filter_list</mat-icon>
        <span class="ms-2">Filtri</span>
      </mat-panel-title>
      <mat-panel-description *ngIf="!filterPanelOpenState">
        {{ getActiveFilterCount() }} filtri attivi
      </mat-panel-description>
    </mat-expansion-panel-header>

    <!-- Basic Filters -->
    <div class="row w-100">
      <!-- Amount Range -->
      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo minimo</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="filters.amount_gt"
            name="amount_gt"
          />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>
      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo massimo</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="filters.amount_lt"
            name="amount_lt"
          />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Data di emissione da</mat-label>
        <input
          matInput
          [matDatepicker]="emissionStartPicker"
          [(ngModel)]="filters.emission_date_after"
          name="emission_date_after"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="emissionStartPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #emissionStartPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Data di emissione a</mat-label>
        <input
          matInput
          [matDatepicker]="emissionEndPicker"
          [(ngModel)]="filters.emission_date_before"
          name="emission_date_before"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="emissionEndPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #emissionEndPicker></mat-datepicker>
      </mat-form-field>

    </div>

    <!-- Advanced Filters Toggle -->
    <!-- <mat-slide-toggle [(ngModel)]="advancedFilters" class="mb-0">
      Filtri avanzati
    </mat-slide-toggle> -->

    <!-- Advanced Filters (hidden by default) -->
    <div class="advanced-filters" *ngIf="advancedFilters">
      <mat-divider class="my-3"></mat-divider>

      <div class="row w-100 mb-0">
        <!-- Emission Date Range -->
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di emissione da</mat-label>
            <input
              matInput
              [matDatepicker]="emissionStartPicker"
              [(ngModel)]="filters.emission_date_after"
              name="emission_date_after"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di emissione a</mat-label>
            <input
              matInput
              [matDatepicker]="emissionEndPicker"
              [(ngModel)]="filters.emission_date_before"
              name="emission_date_before"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionEndPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Payment Date Range -->
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di pagamento da</mat-label>
            <input
              matInput
              [matDatepicker]="paymentStartPicker"
              [(ngModel)]="filters.payment_date_after"
              name="payment_date_after"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="paymentStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #paymentStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di pagamento a</mat-label>
            <input
              matInput
              [matDatepicker]="paymentEndPicker"
              [(ngModel)]="filters.payment_date_before"
              name="payment_date_before"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="paymentEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #paymentEndPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="d-flex justify-content-end gap-2 mt-2 w-sm-100">
      <button mat-stroked-button color="warn" (click)="resetFilters()">
        <mat-icon>clear</mat-icon>
        Cancella
      </button>
      <button mat-raised-button color="primary" (click)="loadpreventives()">
        <mat-icon>search</mat-icon>
        Applica filtri
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!-- Colored cards -->
<!-- <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-2 mt-3 mb-3 hidden-mobile">
  <mat-card class="flex-grow-1 d-flex flex-column clickable-yellow custom-card-yellow">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ totalpreventives }}</span>Total preventives
      </mat-card-title>
    </mat-card-header>
  </mat-card>

  <mat-card class="flex-grow-1 d-flex flex-column clickable-blue custom-card-blue">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ paidpreventives }}</span>Paid preventives
      </mat-card-title>
    </mat-card-header>
  </mat-card>

  <mat-card class="flex-grow-1 d-flex flex-column clickable-pink custom-card-pink">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ totalpreventives - paidpreventives }}</span>
        Unpaid preventives
      </mat-card-title>
    </mat-card-header>
  </mat-card>
</div> -->

<div class="mt-3 mb-3 d-flex justify-content-between align-items-center">
  <!-- Filter chips -->
  <mat-chip-set aria-label="Filter selection" class="flex-grow-1">
    <mat-chip-option
      *ngFor="let option of filterOptions"
      [value]="option.value"
      [selected]="selectedFilter === option.value"
      (click)="applyFilter(option.value)"
    >
      {{option.name}}
    </mat-chip-option>
  </mat-chip-set>

  <button
    mat-raised-button
    (click)="navigateTonewPreventive()"
    class="ms-3 primary-button"
    matButton="filled"
  >
    <mat-icon>add</mat-icon>
    Nuovo
  </button>
</div>

<!-- with this we can add a loading state -->
<!-- <div *ngIf="isLoading">Loading preventives...</div> -->

<mat-card
  class="mb-3 mb-md-0 col-md-12 d-flex flex-column custom-card hidden-mobile"
>
  <mat-card-content>
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricando fatture...</p>
    </div>
    <!-- Show empty state when no data -->
    <div *ngIf="dataSource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
      <img 
        src="izy_image_5_small.png" 
        alt="Nessun cliente"
        class="empty-state-image mb-3"
        style="max-width: 300px; opacity: 1;"
      >
      <h4 class="text-muted">Ancora nessun preventivo qui...</h4>
      <p class="text-muted">Crea il tuo primo preventivo con il tasto in alto!</p>
    </div>

    <!-- when loaded and there is something in the table  -->
    <table
      *ngIf="dataSource.filteredData.length > 0"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="announceSortChange($event)"
      class="mat-elevation-z8 hidden-mobile"
    >
      <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

      <!-- Actions Column -->
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef>Azioni</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon
            matButton
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            >more_vert</mat-icon
          >
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="onRowClick(element)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <button mat-menu-item (click)="openCustomerPage(element)">
              <mat-icon>account_box</mat-icon>
              <span>Vedi cliente</span>
            </button>
            <button mat-menu-item (click)="downloadPreventivePdf(element.id)">
              <mat-icon>download</mat-icon>
              <span>Salva PDF</span>
            </button>
            <button mat-menu-item (click)="sendInvoiceEmail(element.id, element)">
              <mat-icon>outgoing_mail</mat-icon>
              <span>Invia per email</span>
            </button>
            <!-- <button mat-menu-item (click)="publishDraft(element)">
              <mat-icon>send</mat-icon>
              <span>Converti in fattura</span>
            </button> -->
            <!-- <button mat-menu-item (click)="navigateTonewPreventive()">
              <mat-icon>copy_all</mat-icon>
              <span>Duplica</span>
            </button> -->
            <!-- TODO: delete preventive  -->
            <button mat-menu-item (click)="deletepreventive(element)" class="text-danger">
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="document_type">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by document type"
        >
          Tipo
        </th>
        <td mat-cell *matCellDef="let element">{{ getDocumentTypeName(element.document_type!) }}</td>
      </ng-container>

      <!-- <ng-container matColumnDef="invoice_name">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Name"
        >
          Nome
        </th>
        <td mat-cell *matCellDef="let element">{{element.invoice_name}}</td>
      </ng-container> -->

      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Amount"
        >
          Importo
        </th>
        <td mat-cell *matCellDef="let element">{{element.amount | currency:newPreventive.currency:'symbol':'1.2-2' }}</td>
      </ng-container>

      <!-- Company Platform Column -->
      <!-- <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef>Valuta</th>
        <td mat-cell *matCellDef="let element">{{element.currency}}</td>
      </ng-container> -->

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef>Cliente</th>
        <td mat-cell *matCellDef="let element">
          {{element.company.company_name}}
        </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Oggetto</th>
        <td mat-cell *matCellDef="let element">{{element.description}}</td>
      </ng-container>

      <!-- Emission date Column -->
      <ng-container matColumnDef="emission_date">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Emission"
        >
          Data di creazione
        </th>
        <td mat-cell *matCellDef="let element">{{element.emission_date | date:'dd/MM/yyyy' }}</td>
      </ng-container>

      <!-- Progressive number -->
      <ng-container matColumnDef="preventives_progressive_number">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Amount"
        >
          Progressivo prev.
        </th>
        <td mat-cell *matCellDef="let element">{{element.preventives_progressive_number }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
        (mouseenter)="onRowHover(row)"
        [matTooltip]="getRowTooltip(row)"
        matTooltipClass="row-summary-tooltip"
        matTooltipPosition="above"
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      ></tr>
    </table>

    <!-- Add the paginator at the bottom of the table -->
    <mat-paginator
      [pageSizeOptions]="[10, 20, 50, 100]"
      [pageSize]="20"
      showFirstLastButtons
      class="hidden-mobile"
    >
    </mat-paginator>

    <mat-divider class="visible-mobile"></mat-divider>
  </mat-card-content>
</mat-card>

<!-- Mobile Cards -->
<div class="mobile-cards visible-mobile">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricando fatture...</p>
  </div>
  <!-- Empty state for mobile -->
  <div *ngIf="filteredpreventives.length === 0 && !isLoading" class="empty-state text-center py-5">
    <img 
      src="izy_image_5_small.png" 
      alt="Nessun cliente"
      class="empty-state-image mb-3"
      style="max-width: 250px; opacity: 1;"
    >
    <h4 class="text-muted">Ancora nessun preventivo qui...</h4>
      <p class="text-muted">Crea il tuo primo preventivo con il tasto in alto!</p>
  </div>

  <mat-card *ngFor="let item of filteredpreventives">

    <mat-card-header class="d-flex mb-1 justify-content-between align-items-center w-100 mobile-header">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h6 class="mb-1 text-start"><strong>{{item.company.company_name || 'N/A'}}</strong></h6>
        <h6 class="mb-1 text-end"><strong>{{item.amount | currency:item.currency:'symbol':'1.2-2' }}</strong></h6>
      </div>
    </mat-card-header>

    <mat-card-content>
      <div class="d-flex m-0 justify-content-between align-items-center">
        <p class="mb-1 text-small">Preventivo N.{{item.progressive_number || 'N'}} del {{item.emission_date | date:'dd/MM/yyyy'}}</p>
        <!-- Right arrow icon -->
        <mat-icon matButton [matMenuTriggerFor]="menu">more_vert</mat-icon>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item (click)="onRowClick(item)">
            <mat-icon>manage_search</mat-icon>
            <span>Vedi dettagli</span>
          </button>
          <button mat-menu-item (click)="openCustomerPage(item)">
              <mat-icon>account_box</mat-icon>
              <span>Vedi cliente</span>
            </button>
          <button mat-menu-item (click)="downloadPreventivePdf(item.id)">
            <mat-icon>download</mat-icon>
            <span>Download PDF</span>
          </button>
          <button mat-menu-item (click)="sendInvoiceEmail(item.id, item)">
              <mat-icon>outgoing_mail</mat-icon>
              <span>Invia per email</span>
            </button>
          <!-- <button mat-menu-item (click)="navigateTonewPreventive()">
            <mat-icon>copy_all</mat-icon>
            <span>Duplica</span>
          </button> -->
          <button mat-menu-item (click)="deletepreventive(item)" class="text-danger">
            <mat-icon color="warn">delete</mat-icon>
            <span>Elimina</span>
          </button>
        </mat-menu>
      </div>

    </mat-card-content>

    <div class="d-flex mt-2 mb-0 justify-content-between align-items-center white-bg">
        
        <div class="ms-0 d-flex align-items-center mb-2">
          <mat-chip
            color="primary"
            class="me-0 ms-2 mt-1"
          >
          Preventivo
          </mat-chip>
        </div>

        <button mat-stroked-button (click)="onRowClick(item)" class="me-2">
          <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0">Dettagli</p>
          <span>
            <mat-icon class="ms-3 mt-1 m-0">chevron_right</mat-icon>
          </span>
          </div>
        </button>

        <!-- <div class="mb-1 d-flex justify-content-end">
          <mat-chip 
            [color]="getStatusColor(item.status)" 
            selected>
            {{item.status}}
          </mat-chip>
        </div> -->
      </div>

  </mat-card>

  <!-- Update paginator to use filteredpreventives length -->
  <!-- <mat-paginator
    [length]="filteredpreventives.length"
    [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10"
    showFirstLastButtons
  >
  </mat-paginator> -->
</div>